<template>
    <div class="crowdDetails pages">
        <div class="title mb-30">
            <p>
                <img src="../../assets/images/newIcon/addchannel_title_icon.png" alt="">
                <span>新增营销计划</span>
            </p>
            <p>
            </p>
        </div>
        <ul class="checkTab mb-30">
            <li :class="{'active':types==1 || types==2 || types==3}">
                <p>
                    1
                </p>
                <p>
                    <span>基本信息</span>
                    <span>请填写分组的基础信息，<br/> 方便管理会员分组</span>
                </p>
            </li>
            <li :class="{'active':types==2 || types==3}">
                <p>
                    2
                </p>
                <p>
                    <span>场景规则</span>
                    <span>设置场景规则，<br/>360度会员透视</span>
                </p>
            </li>
            <li :class="{'active':types==3}">
                <p>
                    3
                </p>
                <p>
                    <span>计划配置</span>
                    <span>设置营销计划内容</span>
                </p>
            </li>
        </ul>
        <div class="content">
            <div class="f1" v-if="types==1">
                <el-form ref="form" :model="form" label-width="120px" size="mini">
                    <el-form-item label="计划名称:" prop="name" :rules="{
                    required: true, message: '请输入计划名称', trigger: 'blur'
                    }">
                        <el-input v-model="form.name" placeholder="请输入计划名称"></el-input>
                    </el-form-item>
                    <el-form-item label="业务系统:" prop="" :rules="{
                    required: true
                    }">
                   <el-select v-model="value" placeholder="请选择业务系统">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    </el-form-item>
                    <el-form-item :style="form.radtype==1 ? 'margin-bottom:60px;' : 'margin-bottom:20px;'" style="positon:relative;" label="计划方式:" class="jihua" :rules="{required: true}">
                        <el-radio-group v-model="form.radtype">
                            <el-radio label="1">单次</el-radio>
                            <el-radio label="2">重复</el-radio>
                        </el-radio-group>
                        <p class="mj" v-if="form.radtype==1">
                            <span>触发时间：在</span>
                             <el-date-picker
                            v-model="form.name2"
                            type="date"
                            placeholder="选择日期">
                            </el-date-picker>
                            <el-time-picker
                                arrow-control
                                v-model="form.timevalue"
                                :picker-options="{
                                selectableRange: '00:00:00 - 23:59:59'
                                }"
                                placeholder="选择时间">
                            </el-time-picker>
                            <span>对受众群体进行触达</span>
                        </p>
                        <div class="cf" v-if="form.radtype==2">
                            <div>
                                <span class="lab">起止时间：</span>
                                <div>
                                    <p><el-date-picker
                                    type="daterange"
                                    range-separator="→"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                                    </el-date-picker></p>
                                    <p class="tips">活动的起止日期，活动仅在有效日期内可触发</p>
                                </div>
                            </div>
                            <div>
                                <span class="lab">触发时间：</span>
                                <div>
                                    <p> <span>每天</span> <el-time-picker
                                    arrow-control
                                    v-model="form.timevalue"
                                    :picker-options="{
                                    selectableRange: '00:00:00 - 23:59:59'
                                    }"
                                    placeholder="选择时间">
                                    </el-time-picker></p>
                                    <p class="tips">当到达了触发时间后，将对受众群体进行触达</p>
                                </div>
                            </div>
                            <div>
                                <span class="lab">参与限制：</span>
                                <div>
                                    <p>
                                        <el-radio-group v-model="form.radtype2">
                                            <el-radio label="1">参与1次</el-radio>
                                            <el-radio label="2">参与多次</el-radio>
                                        </el-radio-group>
                                    </p>
                                     <p class="cany">
                                        <span>同一个用户</span>
                                          <el-input v-model="form.name3" placeholder=""></el-input>
                                        <span>天内，最多参与</span>
                                        <el-input v-model="form.name4" placeholder=""></el-input>
                                        <span>次</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="f3" v-if="types==2">
                <div class="checks mb-30">
                    <span class="t">触发条件:</span>
                    <p>
                        <span @click="checked=1" :class="checked==1 ? 'active' : ''">
                            <img v-if="checked!=1" src="../../assets/images/newIcon/chufa_gray_icon.png" alt="">
                            <img v-if="checked==1" src="../../assets/images/newIcon/chufa_icon.png" alt="">
                            <img v-if="checked==1" class="check" src="../../assets/images/newIcon/chafa_xuanzhong_bg.png" alt="">
                            触发型-完成A
                        </span>
                        <span @click="checked=2" :class="checked==2 ? 'active' : ''">
                            <img v-if="checked!=2" src="../../assets/images/newIcon/chufa_gray_icon.png" alt="">
                            <img v-if="checked==2" src="../../assets/images/newIcon/chufa_icon.png" alt="">
                            <img v-if="checked==2" class="check" src="../../assets/images/newIcon/chafa_xuanzhong_bg.png" alt="">
                            触发型-未完成A
                        </span>
                        <span @click="checked=3" :class="checked==3 ? 'active' : ''">
                            <img v-if="checked!=3" src="../../assets/images/newIcon/chufa_gray_icon.png" alt="">
                            <img v-if="checked==3" src="../../assets/images/newIcon/chufa_icon.png" alt="">
                            <img v-if="checked==3" class="check" src="../../assets/images/newIcon/chafa_xuanzhong_bg.png" alt="">
                            触发型-未完成A-未完成b
                        </span>
                    </p>
                </div>
                <featuresPopulation @dostep="shows" :conditionType="checked" type="4" ref="featuresPopulation"></featuresPopulation>
            </div>
            <div class="f2" v-if="types==3 && !showOk">
                <el-form ref="form" :model="form" label-position="left" label-width="100px" size="mini">
                    <el-form-item label="通知渠道:" prop="name" :rules="{
                    required: true, message: '请输入计划名称', trigger: 'blur'
                    }">
                        <ul class="channel">
                            <li>
                                <el-checkbox-group v-model="checkList">
                                    <el-checkbox label="1">短信通知</el-checkbox>
                                    </el-checkbox-group>
                                    <p class="ft">扣除店铺短信条数，为了发送成功，请确保在<span>消息推送</span>设置了自定义签名</p>
                                    <div class="tent">
                                        <p class="ic"  ><i @click="showChan(2)" class="el-icon-plus"></i></p>
                                        <p class="text">配置短信通知</p>
                                    </div>
                            </li>
                            <li>
                                <el-checkbox-group v-model="checkList">
                                    <el-checkbox label="2">公众号通知</el-checkbox>
                                    </el-checkbox-group>
                                    <p class="ft">根据<span>《微信公众平台运营规范》</span>，频繁发送营销类模版消息存在被封禁的风险。</p>
                                    <div class="tent">
                                        <p class="t">未绑定认证服务号，无法使用</p>
                                        <p class="text"  @click="showChan(1)">去绑定</p>
                                    </div>
                            </li>
                            <li>
                                <el-checkbox-group v-model="checkList">
                                    <el-checkbox label="3">push推送</el-checkbox>
                                    </el-checkbox-group>
                                    <p class="ft">可提高产品功能和营销活动的用户参与度，频繁发送可能会造成用户卸载率提高的风险。</p>
                                    <div class="tent">
                                        <p class="t">未绑定极光推送/友盟，无法使用</p>
                                        <p class="text"  @click="showChan(3)">去绑定</p>
                                    </div>
                            </li>
                            <li>
                                <el-checkbox-group v-model="checkList">
                                    <el-checkbox label="4">应用弹窗</el-checkbox>
                                    </el-checkbox-group>
                                    <p class="ft">选择应用渠道，发送应用弹窗给用户</p>
                                    <div class="uploads">
                                    <p>
                                        <span>推送渠道：</span>
                                        <el-select v-model="value" placeholder="请选择">
                                            <el-option
                                            v-for="item in options"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </p>
                                    <p>
                                        <span>弹窗图片：</span>
                                        <el-upload
                                            class="avatar-uploader"
                                            action="https://jsonplaceholder.typicode.com/posts/"
                                            :show-file-list="false"
                                            :on-success="handleAvatarSuccess"
                                            :before-upload="beforeAvatarUpload">
                                            <img v-if="imageUrl" :src="imageUrl" class="avatar">
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        <span class="shili">示例</span>
                                    </p>
                                    </div>
                            </li>
                        </ul>
                    </el-form-item>
                     <el-form-item class="chufa" label="权益设置:" :rules="{required: true}">
                        <el-radio-group v-model="form.type">
                                <el-radio label="1">优惠券
                                </el-radio>
                        </el-radio-group>
                        <p class="tips" style="margin-left:25px;">发放优惠券能有效刺激转化（优惠券将直接发放给客户，不需要领取）</p>
                        <p><el-button @click="showC" type="primary" icon="el-icon-plus">添加优惠券</el-button></p>
                        <div>
                            <div class="tabTitle">
                                <p>共<span>100</span>条 已选中<span>0</span>条</p>
                                <el-button round icon="el-icon-delete">批量删除</el-button>
                            </div>
                            <el-table
                                :data="tableData3"
                                :header-cell-style="{background:'#EEEEEE',textAlign: 'center',fontSize:'12px'}"
                                style="width: 100%;"
                                :cell-style="{textAlign: 'center',fontSize:'12px'}"
                                >
                                <el-table-column
                                type="selection"
                                width="55">
                                </el-table-column>
                                <el-table-column
                                prop="name"
                                label="优惠券名称"
                                show-overflow-tooltip
                                >
                                </el-table-column>

                                <el-table-column
                                prop="number"
                                label="类型"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="number"
                                label="业务系统"
                                
                                cell-style="background:red;"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="xmember"
                                label="内容"
                            >
                                </el-table-column>
                                <el-table-column
                                prop="lmember"
                                label="状态"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="num"
                                label="已领取"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="num"
                                label="剩余"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="num"
                                label="已使用"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="num"
                                label="操作"
                                >
                                    <template slot-scope="scope">
                                        <el-button type="text">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-form-item>
                    <el-form-item class="chufa" label="完成定义:" :rules="{required: true}">
                        <p class="tips" style="padding-top:0;">若推送的群体完成了所选择的动作，则视为完成。用于统计计划的有效性</p>
                        <div>
                            <el-radio-group v-model="form.type">
                                <div class="mb-15">
                                    <el-radio label="1">消费
                                    </el-radio>
                                </div>
                                <div class="mb-15">
                                    <el-radio label="2">登录系统
                                    </el-radio>
                                </div>
                                <div class="mb-15">
                                    <el-radio label="3">点击链接
                                    </el-radio>
                                </div>
                                
                            </el-radio-group>
                        </div>
                    </el-form-item>
                    <el-form-item class="chufa" label="标签:" :rules="{required: true}">
                         <el-button @click="showPopup(5)"  type="text" icon="el-icon-plus">添加标签</el-button>
                        <div>
                            <el-tag size="medium" closable>沈阳市</el-tag>
                            <el-tag size="medium" closable>沈阳市</el-tag>
                            <el-tag size="medium" closable>沈阳市</el-tag>
                            <el-tag size="medium" closable>沈阳市</el-tag>
                            <el-tag size="medium" closable>沈阳市</el-tag>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="tab3" v-show="showOk && types==3">
                <p><img src="../../assets/images/newIcon/chenggong_icon.png" alt=""></p>
                <p>创建成功</p>
                <p>自定义营销计划创建已完成</p>
                <!-- <p>预计导入xxx人数，成功后可在会员导入中查看</p> -->
                <p>
                    <el-button round>返 回</el-button>
                </p>
            </div>
            <!-- {{}} -->
            <span v-if="types!=2 && !showOk" class="footer">
                <el-button class="quxiao" @click="handleClose" v-if="types==1">取 消</el-button>
                <el-button class="quxiao"  @click="types=--types" v-if="types==2 || types==3">上一步</el-button>
                <el-button type="primary"  @click="types=2" v-if="types==1">下一步</el-button>
                <el-button type="primary" v-if="types==3" @click="createOk">完 成</el-button>
            </span>
        </div>
        <!-- 标签 -->
        <customer-popup @doSelect='doSelect' ref="customerPopup"></customer-popup>
        <!-- 渠道 -->
        <selectChannels ref="selectChannels"></selectChannels>
        <!--  -->
        <selectCoupon ref="selectCoupon"></selectCoupon>
    </div>
</template>
<script>
import featuresPopulation from '../memberCenter/components/featuresPopulation'
import selectChannels from './components/selectChannels'
import selectCoupon from './components/selectCoupon'
export default {
    data() {
        return {
            types:1,
            tableData: [{
                name: '新客户人群',
                address: '129,000'
            }],
            showOk:false,
            checked:"1",
            checkList:[],
            tableData3: [{
                name: '生日活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '6.1活动券',
                number:"折扣券",
                xmember:"业务系统",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '双11大额优惠券',
                number:"优惠券",
                xmember:"积分商城",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '特大聚汇活动',
                number:"代金券",
                xmember:"业务系统",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '生日活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '生日活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '生日活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '生日活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '生日活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
            },],
            options: [{
            value: '选项1',
            label: '小橘帮帮'
            },],
            value: '',
            form: {
                radtype2:'1',
                radtype:"2",
                name: '',
                name2: '',
                name3: '',
                name4: '',
                region: '',
                date1: '',
                date2: '',
                timevalue:"",
                delivery: false,
                type: [],
                resource: '',
                desc: ''
            }
        }
    },
    components:{
        featuresPopulation,
        selectChannels,
        selectCoupon
    },
    methods:{
        showC(){
            this.$refs.selectCoupon.show()
        },
        handleClose(){
            this.$router.go(-1)
        },
        showChan(type){
            this.$refs.selectChannels.show(type)
        },
          showPopup(type){
            this.$refs.customerPopup.show(type);
        },
        createOk(){
            this.showOk=true;
        },
        shows(obj){
            if(obj.type==1){
                this.types=1;
            }else{
                this.types=3;
            }
            
            console.log(obj,1111111)
        }
    }
}
</script>
<style lang="less" scoped>
    .tab3{
        padding:100px 0;
        background: #fff;
        border-radius: 6px;
        p{
            margin-bottom:15px;
            text-align: center;
            img{
                width:68px;
                height:68px;
            }
            &:nth-child(2){
                font-size: 18px;
                font-weight: 400;
                color: #333333;
            }
            &:nth-child(3){
                font-size: 14px;
                font-weight: 400;
                color: #777777;
            }
            &:nth-child(4){
                font-size: 16px;
                font-weight: 500;
                color: #333333;
            }
            &:last-child{
                font-size: 14px;
                font-weight: 400;
                color: #777777;
            }
        }
    }
    .title{
        display: flex;
        justify-content: space-between;
        p{
            font-size: 16px;
            font-weight: 500;
            color: #333940;
            img{
                margin-right:10px;
                width:20px;
                height:20px;
                vertical-align: middle;
                &:last-child{
                    margin-left:10px;
                    width:78px;
                    height:20px;
                }
            }
            &:last-child{
                span{
                    color: #0091FF;
                }
            }
            
        }
    }
    .footer{
        display: block;
        background: #fff;
        padding:15px 30px;
        border-top:1px solid #ededed;
        .el-button{
            border-radius: 30px;
        }
    }
    .checkTab{
        background: #fff;
        padding:60px 0;
        display: flex;
        justify-content: center;
        border-radius: 6px;
        img{
            width:28px;
            height:28px;
        }
        li{
            display: flex;
            align-items: center;
            margin-right:220px;
            position: relative;
            &:last-child{
                margin:0;
                &::after{
                    left: -206px;
                }
            }
            &:first-child{
                
                &::after{
                    display:none;
                }
                
            }
            &:nth-child(2){
                &::after{
                    left: -205px;
                }
                
            }
            
            &::after{
                content: '';
                position: absolute;
                top: 30px;
                border-bottom: 1px dashed #A7A7A7;
                width: 190px;
                height: 2px;
            }
        }
        .active{
            &::after{
                border-bottom: 1px dashed #327EFF;
            }
            p{
                &:last-child{
                    color: #327EFF;
                }
                &:first-child{
                    background: linear-gradient(180deg, #587FFB 0%, #3968FC 100%);
                    color:#fff;
                }
                span{
                    &:first-child{
                        color:#327EFF;
                    }
                    &:last-child{
                        color:#484848;
                    }
                }
            }
        }
        p{
            // text-align: center;
            &:first-child{
                margin:0 auto;
                margin-right:20px;
                width: 58px;
                height: 58px;
                border-radius: 50%;
                line-height: 63px;
                text-align: center;
                background: #EBEBEB;
                font-size: 34px;
                font-weight: 500;
                color: #fff;
            }
            &:last-child{
                font-size: 14px;
                font-weight: 400;
                color: #A1A1A1;
                span{
                    display: block;
                    color: #999990;
                    &:first-child{
                        margin-bottom:10px;
                        font-size: 20px;
                        font-weight: 500;
                        
                    }
                }
            }
        }
    }
      /deep/.el-input .el-input__inner{
                border-radius: 30px;
                background: #F6F6F6;
                border: 0px;
            }
    .content{
        .f1{
            border-radius: 6px;
            padding:30px;
            padding-bottom:100px;
            background: #fff;
           
            .chufa{
                /deep/ .el-form-item__content{
                    padding-top:10px;
                }
                .z{
                    margin-bottom:15px;
                    padding:15px 0;
                    padding-left:25px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #666666;
                }
            }
            .cf{
                margin-top:15px;
            }
            .cf>div{
                display: flex;
               &:first-of-type{
                   /deep/ .el-date-editor{
                       border-radius: 30px;
                       background: #F6F6F6;
                       border:0px;
                       .el-range-input{
                           background: #F6F6F6;
                       }
                       .el-range-separator{
                           color:#C6C8CC;
                           font-size:18px;
                       }
                   }
               }
               &:nth-child(2){
                   p{
                       span{
                           padding-right: 10px;
                            font-size: 12px;
                        font-weight: 400;
                        color: #666666;
                       }
                      
                   }
               }
               .cany{
                   /deep/ .el-input{
                       width:50px;
                       padding:10px ;
                   }
                   span{
                       
                        font-size: 12px;
                        font-weight: 400;
                        color: #666666;
                   }
                  
               }
                // align-items: center;
            }
            .cf{
                .lab{
                    font-size: 12px;
                    font-weight: 400;
                    color: #666666;
                }
                // display: flex;
            }
            .mj{
                width:700px;
                margin-top: 6px;
                position: absolute;
                display: flex;
                font-size: 14px;
                font-weight: 400;
                color: #6C6C6C;
                /deep/ .el-date-editor{
                    width:150px;
                    margin:0 6px;
                }
            }
            .el-form{
                width:50%;
                img{
                    width:16px;
                    height:16px;
                    vertical-align: middle;
                }
            }
            .jihua .el-button{
                margin-bottom:15px;
                background: #FFECDF;
                font-size: 14px;
                font-weight: 400;
                color: #FA6400;
                border:0px;
                
            }
             /deep/.el-select{
                width:100%;
            }
            // .jihua{
            //     p{
            //         span{
            //             color:#666666;
            //         }
            //         font-size: 14px;
            //         font-weight: 400;
            //         color: #000;
            //     }
            // }
            // .jihua2{
            //     .el-button{
            //          background: #DFF1FF;
            //          color:#0091FF;
            //     }
            // }
        }
        .tips{
                padding:15px 0;
                font-size: 12px;
                font-weight: 400;
                color:#999;
                i{
                     color: #E02020;
                }
        }
        .f2{
            padding:30px;
            background: #fff;
            .channel{
                display: flex;
                flex-wrap: wrap;
                li{
                    margin-right:2%;
                    margin-bottom:20px;
                    width:31%;
                    padding:15px;
                    box-sizing: border-box;
                    background: #F9F9F9;
                    border-radius: 6px;
                    border: 1px solid #F4F3F3;
                    /deep/ .el-checkbox__label{
                        font-weight: 500;
                        color: #333333;
                    }
                    .ft{
                        height:45px;
                        font-size: 12px;
                        font-weight: 400;
                        color: #777777;
                        line-height: 16px;
                        span{
                            color:#3373FE;
                        }
                    }
                    .uploads{
                        height:145px;
                        padding:15px 15px;
                        padding-left:30px;
                        background: #fff;
                        /deep/.avatar-uploader{
                            width:80px;
                            height:80px;
                        }
                        p{
                            display: flex;
                            margin-bottom:30px;
                           /deep/ .el-input__inner{
                               border-radius:8px;
                               width:100px;
                               background: #F6F6F9;
                           }
                            span{
                                font-size: 12px;
                                font-weight: 400;
                                color: #777777;
                            }
                            .shili{
                                margin-left:15px;
                                color:#3373FE;
                            }
                        }
                    }
                    .tent{
                        display: flex;
                        flex-direction:column;
                        justify-content: center;
                        height:145px;
                        // margin-top:15px;
                        background: #fff;
                        text-align: center;
                        .ic{
                            font-size:28px;
                            color:#327EFF
                        }
                        .t{
                            font-size: 12px;
                            font-weight: 400;
                            color: #777777;
                        }
                        .text{
                            font-size: 12px;
                            font-weight: 400;
                            color: #3373FE;
                        }
                    }
                }
            }
            .tabTitle{
                margin-top:15px;
                margin-bottom:6px;
                padding:8px 30px;
                background: rgba(50, 126, 255, 0.1);
                border-radius: 4px;
                border: 1px solid #C8D8F5;
                display: flex;
                justify-content: space-between;
                /deep/ .el-button{
                    border: 1px solid #327EFF;
                    font-size: 12px;
                    font-weight: 400;
                    color: #327EFF;
                    background: #EAF2FF;
                }
                p{
                    font-size: 16px;
                    font-weight: 500;
                    color: #333940;
                    span{
                        color:#327EFF;
                    }
                }
            }
           
            /deep/ .el-checkbox__inner{
                border-radius: 50%;
            }
            /deep/ .el-tag{
                border-radius: 30px;
                margin-right:10px;
                margin-bottom:10px;
            }
        }
        .f3{
            .checks{
                display: flex;
                align-items: center;
                .t{
                    margin-right:15px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                }
                p{
                    .active{
                        border:1px solid #327EFF;
                        color:#327EFF;
                    }
                    span{
                        position: relative;
                        img{
                            width:16px;
                            height:16px;
                            vertical-align: middle;
                        }
                        .check{
                            position: absolute;
                            right:0;
                            bottom:0;
                        }
                        margin-right:15px;
                        padding:10px 6px;
                        display: inline-block;
                        font-size: 14px;
                        font-weight: 400;
                        color: #595959;
                        background: #FFFFFF;
                        border-radius: 4px;
                        border: 1px solid #DEDEDE;
                    }
                }
            }
        }
    }
</style>